import DisputesService from '../services/disputes-service';
import DisputeService from '../services/dispute-service';

export const disputes = {
  namespaced: true,
  state: {
    project: null,
    dispute: null,
    auditTimeline: null,
    disputeUpdateMessage: null,
    disputeOwners: [],
  },
  actions: {
    initDispute({ commit }, dispute) {
      commit('setDispute', dispute);
      commit('setAuditTimeline', null);
    },
    getByProjectReference(...[, projectReference]) {
      return DisputeService.getByProjectReference(projectReference);
    },
    getByLodgementCertificateNumber(...[, lodgementCertificateNumber]) {
      return DisputeService.getByLodgementCertificateNumber(lodgementCertificateNumber);
    },
    getByUMR(...[, umr]) {
      return DisputeService.getByUMR(umr);
    },
    getProject({ commit }, id) {
      commit('setIsBusy', true, { root: true });
      commit('setProject', []);
      return DisputesService.getProject(id)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setProject', result.model);
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    authorise({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      // commit('setBlockedEmails', []);
      return DisputesService.authorise(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    create({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return DisputeService.create(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setDispute', result.model);
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    update({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return DisputeService.update(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setDispute', result.model);
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    delete({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return DisputeService.delete(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    get({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      commit('setDispute', null)
      commit('setAuditTimeline', null)
      return DisputeService.get(payload)
        .then((result) => {
          commit('setDispute', result.model);
          if (result.model?.source?.uprn) {
            DisputeService.getAuditTimeline({uprn: result.model.source.uprn}).then((response) => {
              commit('setAuditTimeline', response.model);
              commit('setIsBusy', false, { root: true });
              return Promise.resolve(result.model);
            })
          } else {
            commit('setIsBusy', false, { root: true });
            return Promise.resolve(result.model);
          }
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    clearDispute({ commit }) {
      commit('setDispute', null);
    },
    getAuditTimeline({ commit }, uprn) {
      if (uprn) {
        commit('setIsBusy', true, { root: true });
        return DisputeService.getAuditTimeline({uprn: uprn})
          .then((response) => {
            commit('setAuditTimeline', response.model);
            commit('setIsBusy', false, { root: true });
            return Promise.resolve(response.model);
          })
          .catch((error) => {
            commit('setIsBusy', false, { root: true });
            return Promise.reject(error);
          });
      } else {
        commit('setAuditTimeline', null);
        return Promise.resolve(null);
      }
    },
    deleteFollowUpDate({ commit, dispatch }, payload) {
      commit('setIsBusy', true, { root: true });
      return DisputeService.deleteFollowUpDate(payload)
        .then(async (result) => {
          await new Promise(resolve => setTimeout(resolve, 3000));
          const response = await dispatch('disputeSearch/getFollowUpDateCount', {}, { root: true })
          commit('disputeSearch/setFollowUpDateCount', response.followUpDateCount, { root: true });
          commit('setIsBusy', false, { root: true });
          commit('setFollowUpDateDeleted', true)
          return Promise.resolve(result);        
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    listDisputeOwners({ commit }) {
      return DisputeService.listDisputeOwners().then(
        (result) => {
          commit('setDisputeOwners', result);
        }
      );
    },
    updateFollowUpDate({ commit, dispatch }, payload) {
      commit('setIsBusy', true, { root: true });
      return DisputeService.updateFollowUpDate(payload)
        .then(async (result) => {
          await new Promise(resolve => setTimeout(resolve, 3000));
          const response = await dispatch('disputeSearch/getFollowUpDateCount', {}, { root: true })
          commit('disputeSearch/setFollowUpDateCount', response.followUpDateCount, { root: true });
          commit('setIsBusy', false, { root: true });
          commit('setDispute', result.model);
          return Promise.resolve(result.model);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
  },
  mutations: {
    setProject(state, newState) {
      state.project = newState;
    },
    setDispute(state, newState) {
      if (newState) {
        if (newState.dateRaised) {
          newState.dateRaised = new Date(newState.dateRaised);
        }
        if (newState.droTriageDataSharedDate) {
          newState.droTriageDataSharedDate = new Date(newState.droTriageDataSharedDate);
        }
        if (newState.droSchemeNotifiedDate) {
          newState.droSchemeNotifiedDate = new Date(newState.droSchemeNotifiedDate);
        }
        if (newState.droNonEngagmentSentBusinessDate) {
          newState.droNonEngagmentSentBusinessDate = new Date(newState.droNonEngagmentSentBusinessDate);
        }
        if (newState.droInvociedDate) {
          newState.droInvociedDate = new Date(newState.droInvociedDate);
        }
        if (newState.droCompletionDate) {
          newState.droCompletionDate = new Date(newState.droCompletionDate);
        }
        if (newState.caseInvoiceToSchemeDate) {
          newState.caseInvoiceToSchemeDate = new Date(newState.caseInvoiceToSchemeDate);
        }
        if (newState.adjudicationInvoiceToSchemeDate) {
          newState.adjudicationInvoiceToSchemeDate = new Date(newState.adjudicationInvoiceToSchemeDate);
        }
        if (newState.dateComplaintRaisedWithRB) {
          newState.dateComplaintRaisedWithRB = new Date(newState.dateComplaintRaisedWithRB);
        }
        if (newState.dateRaisedWithDRO) {
          newState.dateRaisedWithDRO = new Date(newState.dateRaisedWithDRO);
        }
        if (newState.dateClosed) {
          newState.dateClosed = new Date(newState.dateClosed);
        }

        // Initialize nested objects based on dispute type and subtypes
        if (newState.disputeType === 'Hawthorne' && !newState.disputeHawthorne) {
          newState.disputeHawthorne = {};
        }
        if (newState.disputeType === 'BrandMisuse' && !newState.brandMisuse) {
          newState.brandMisuse = {};
        }
        if (newState.disputeSubtypes && (newState.disputeSubtypes.includes('Hawthorne') || newState.disputeSubtypes.includes('Find & Fix')) && !newState.disputeHawthorne) {
          newState.disputeHawthorne = {};
        }
      }
      state.dispute = newState;
    },
    setAuditTimeline(state, newState) {
      state.auditTimeline = newState;
    },
    setDisputeUpdateMessage(state, newState) {
      state.disputeUpdateMessage = newState;
    },
    setDisputeOwners(state, owners) {
      state.disputeOwners = owners;
    },
    setFollowUpDateDeleted(state, newState) {
      state.dispute.followUpDateDeleted = newState;
      if (newState === true) {
        state.dispute.followUpDate = null;
      }
    },
  },
};
